<template>
  <div class="birdsearch">
    <div class="info">{{ currentAlpha }}</div>
    <div class="helper" v-if="!goalAchieved" :style="helperStyles"></div>
    <div
      class="overlay"
      v-bind:style="{
        opacity: goalCompletion,
        transform: 'translate(-50%, -50%) scale(' + goalCompletion + ')',
      }"
    ></div>
    <div class="success" ref="spectroel" v-if="goalAchieved">
      <canvas ref="oscilloscope" class="canvas oscilloscope"></canvas>
    </div>
    <BirdVisualizer
      :analyser="analyser"
      :stereoPos="stereoPos"
      :distanceDirection="distanceDirection"
      :userAlpha="currentAlphaAccurate"
    />
  </div>
</template>

<script>
import { Howl, Howler } from "howler";
import BirdVisualizer from "./BirdVisualizer";
import axios from "axios";

export default {
  name: "BirdSearch",
  props: ["stationData", "startTime"],
  components: {
    BirdVisualizer,
  },
  data: () => {
    return {
      currentAlpha: 0,
      currentAlphaAccurate: 0,
      targetAlpha: 0,
      targetSet: false,
      goalAchieved: false,
      closeEnough: false,
      analyser: null,
      userPosition: 0,
      goalCompletion: 0,
      currentWaveform: [],
    };
  },
  mounted() {
    this.initOrientation();
    this.initAudio();
    this.updateCompletion();
  },
  computed: {
    helperStyles() {
      // return {};
      return {
        transform: `scale(${this.volume})`,
        opacity: this.volume
      };
    },
    distance() {
      if (!this.currentAlphaAccurate) return 100;
      let dist = Math.abs(
        (this.currentAlphaAccurate % 360) - (this.targetAlpha % 360)
      );
      dist = Math.min(dist, 360 - dist);
      return dist;
    },
    distanceDirection() {
      /* FALSCH */
      let dist = Math.abs((this.currentAlpha % 360) - (this.targetAlpha % 360));
      dist = Math.min(dist, 360 - dist);
      if (this.currentAlpha < this.targetAlpha) {
        dist = dist * -1;
      }
      return dist;
    },
    overlayAlpha() {
      if (this.goalAchieved) return 1;
      if (!this.targetAlpha) return 0;
      if (this.distance > 90) return 0;
      // let a = 1 - (this.easeOut(this.distance / 90));
      let a = 1 - this.distance / 90;
      return a;
    },
    volume() {
      if (this.goalAchieved) return 0.2;
      if (!this.targetAlpha) return 0;
      let a = 1 - this.distance / 180;
      // return this.easeIn(a);
      return a;
    },
    stereoPos() {
      return 0;
      /* FALSCH */
      if (this.goalAchieved) return 0;
      // let pos = this.easeIn(Math.round(this.distance / 1.8) / 100);
      let pos = Math.round(this.distance / 0.18) / 1000;
      if (
        this.targetAlpha > 180 &&
        this.targetAlpha - this.currentAlpha > 180
      ) {
        return pos * -1;
      } else if (
        this.targetAlpha < 180 &&
        this.currentAlpha - this.targetAlpha < 180
      ) {
        return pos * -1;
      }
      return pos;
    },
  },
  methods: {
    initAudio() {
      this.sound = new Howl({
        src: [require("../assets/nachtigall.mp3")],
        autoplay: true,
        loop: true,
        volume: 0,
        onloaderror: () => {
          console.log("load error");
        },
        onplayerror: () => {
          console.log("error");
          this.sound.once("unlock", function () {
            this.sound.play();
          });
        },
        onload: () => {
          this.sound.stereo(0);
        },
      });
      this.analyser = Howler.ctx.createAnalyser();
      this.analyser.connect(Howler.ctx.destination);
    },

    initOrientation() {
      window.addEventListener("deviceorientation", (e) => {
        if (!this.targetSet) {
          this.initTargetAlpha(e.alpha);
        }
        this.handleOrientation(e.alpha);
      });
    },
    initTargetAlpha(alpha) {
      this.targetAlpha = Math.round((alpha + Math.random() * 90 + 135) % 360);
      this.targetSet = true;
    },
    handleOrientation(alpha) {
      this.currentAlphaAccurate = alpha;
      this.currentAlpha = Math.round(alpha * 1000) / 1000;
      this.checkGoal();
    },
    updateCompletion() {
      if (this.distance < 20 && !this.goalAchieved) {
        if (this.goalCompletion < 1)
          this.goalCompletion += (20 - this.distance) * 0.0005;
        if (!this.closeEnough) {
          this.closeEnough = true;
          // this.goalTimeout = window.setTimeout(() => {
          //   this.handleGoalAchieved();
          // }, 3000);
        }
        if (this.goalCompletion >= 1) {
          this.handleGoalAchieved();
        }
      } else {
        if (this.goalCompletion > 0) this.goalCompletion -= 0.01;
        this.closeEnough = false;
        window.clearTimeout(this.goalTimeout);
      }

      if (this.goalAchieved) return;
      window.setTimeout(() => {
        this.updateCompletion();
      }, 30);
    },
    checkGoal() {
      this.sound.volume(this.volume);
      console.log(this.stereoPos);
      this.sound.stereo(this.stereoPos);
    },
    handleGoalAchieved() {
      this.goalAchieved = true;

      this.$nextTick(() => {
        this.initWaves();
      });

      this.soundVoice = new Howl({
        src: [this.stationData.voiceover_success],
        autoplay: true,
      });

      this.soundVoice.on("end", () => {
        window.postMessage("end");
      });

      const userId = new URL(window.location.href).searchParams.get("visitor");
      if (!userId) return;

      const seconds = Date.now() - this.startTime;
      let dScore = 1;
      if (seconds < 600000) {
        dScore = seconds / 600000;
      }

      axios.post(window.apiUrl + "/api/scores", {
        station_id: 1,
        visitor_id: userId,
        score: 0,
        duration: dScore,
        activity: 0,
      });
    },
    initWaves() {
      const analyser = Howler.ctx.createAnalyser();

      Howler.masterGain.connect(analyser);

      const waveform = new Float32Array(analyser.frequencyBinCount);
      analyser.getFloatTimeDomainData(waveform);
      analyser.smoothingTimeConstant = 1;

      const scale = window.devicePixelRatio;
      const $spectroel = this.$refs.spectroel;
      const $canvas = this.$refs.oscilloscope;

      const ctx = $canvas.getContext("2d");
      const rect = $spectroel.getBoundingClientRect();

      $canvas.width = rect.width * scale;
      $canvas.height = rect.height * scale;

      ctx.scale(scale, scale);
      // ctx.fillStyle='#FFFDF9';
      ctx.strokeStyle = "rgba(255,255,255,.2)";
      ctx.lineWidth = 5;

      const waveScaleRatio = rect.width / waveform.length;
      const zoomFactor = 8;

      const draw = (waveform) => {
        requestAnimationFrame(() => {
          draw(waveform);
        });
        analyser.getFloatTimeDomainData(waveform);
        ctx.clearRect(0, 0, $canvas.width, $canvas.height);

        ctx.beginPath();
        ctx.moveTo(0, 0);
        let lastX = 0;

        for (let i = 0; i < waveform.length; i++) {
          if (!this.currentWaveform[i]) this.currentWaveform[i] = 0;
          this.currentWaveform[i] +=
            (waveform[i] - this.currentWaveform[i]) / 5;
          const x = i * waveScaleRatio * zoomFactor;
          const y = (0.5 + this.currentWaveform[i] * 1) * window.innerHeight;
          ctx.lineTo(x, y);
          lastX = x;
        }

        ctx.lineTo(lastX, 0);
        ctx.stroke();
      };

      draw(waveform);
    },
    easeIn(t) {
      return t * t * t * t * t;
    },
    easeOut(t) {
      return 1 + --t * t * t * t * t;
    },
  },
};
</script>

<style scoped lang="scss">
.birdsearch {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.overlay {
  position: absolute;
  width: 120vh;
  height: 120vh;
  top: 50%;
  left: 50%;
  background-color: #f3c880;
  // background-image: url('../assets/particles/02.png');
  // background-size: contain;
  // background-repeat: no-repeat;
  // background-position: center;
  // filter: blur(100px);
  z-index: 4;
  border-radius: 99%;
  // display: none;
}
.info {
  position: relative;
  z-index: 99;
  background: black;
  width: 10rem;
  margin: 0 auto;
  padding: 10px;
  text-align: center;
  display: none;
}
.success {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f3c880;
  z-index: 4;

  .canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.helper {
  display: block;
  width: 25rem;
  height: 25rem;
  background-image: url('../assets/bird-preview.png');
  background-size: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -12.5rem;
  margin-top: -12.5rem;
  z-index: 10;
  border-radius: 99%;
  box-shadow: 0 0 100px 10px #ffe9c2;
}
</style>
